import { ControlledInput, ControlledSelect } from "@dune/ui";
import { gfaOperationTypeToStringMap } from "@dune/vars";
import { useFormContext } from "react-hook-form";

const GFANameAndTypeContainer = () => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	return (
		<div className="border-solid border-1 border-gray-200 rounded-lg p-4 space-y-4 relative">
			<div className="flex flex-row gap-4">
				<ControlledInput
					name="projectName"
					control={control}
					label="Nom du projet"
					placeholder="Nom du projet"
					error={errors.projectName?.message?.toString()}
				/>
				<ControlledSelect
					name={"operationType"}
					control={control}
					label={"Type d'opération"}
					options={Object.entries(gfaOperationTypeToStringMap).map(
						([key, value]) => ({
							label: value,
							value: key,
						}),
					)}
				/>
			</div>
		</div>
	);
};

export default GFANameAndTypeContainer;
